import { Drawer } from "antd";
import { Icon } from "@iconify/react";
import React from "react";
import "./layouts-styles.css";

/**
 * Side panel shell — same title treatment as BaseModal so a form reads
 * identically whether it opens in a dialog or a drawer.
 */
const BaseDrawer = (props) => {
  const { mainTitle, subTitle, icon, width, children, ...rest } = props;

  const title = (
    <div className="modal-title">
      { icon &&
        <span className="modal-title-mark">
          <Icon icon={ icon } width={ 20 } />
        </span> }
      <span className="modal-title-text">
        <span className="modal-title-main">{ mainTitle }</span>
        { subTitle && <span className="modal-title-sub">{ subTitle }</span> }
      </span>
    </div>
  );

  return (
    <Drawer
      maskClosable={ false }
      open
      destroyOnClose
      title={ title }
      width={ width || 'min(520px, 100vw)' }
      className="base-drawer"
      styles={ { body: { padding: 0 } } }
      { ...rest }
    >
      <div className="drawer-body">
        { children }
      </div>
    </Drawer>
  );
};

export default BaseDrawer;
